import { render, staticRenderFns } from "./ConfigurarAlertasPantalla.vue?vue&type=template&id=e1eee06a&"
import script from "./ConfigurarAlertasPantalla.vue?vue&type=script&lang=ts&"
export * from "./ConfigurarAlertasPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('e1eee06a', component.options)
    } else {
      api.reload('e1eee06a', component.options)
    }
    module.hot.accept("./ConfigurarAlertasPantalla.vue?vue&type=template&id=e1eee06a&", function () {
      api.rerender('e1eee06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Camaras/ConfigurarAlertas/ConfigurarAlertasPantalla.vue"
export default component.exports